import classNames from 'classnames';
import React from 'react';
import s from './styles.module.css.json';
/**
 * - @example Basic example
 *
 * ```js
 * <Canvas ctx={ctx}>
 *   <Toolbar>
 *     <ToolbarStack stackSize="l">
 *       <ToolbarTitle>Media Area</ToolbarTitle>
 *     </ToolbarStack>
 *   </Toolbar>
 *   <div
 *     style={{
 *       display: 'flex',
 *       justifyContent: 'center',
 *       alignItems: 'center',
 *       background: 'var(--light-bg-color)',
 *       height: '150px',
 *     }}
 *   >
 *     Main content
 *   </div>
 * </Canvas>;
 * ```
 *
 * @example Buttons and actions
 *
 * ```js
 * <Canvas ctx={ctx}>
 *   <Toolbar>
 *     <ToolbarButton>
 *       <BackIcon />
 *     </ToolbarButton>
 *     <ToolbarStack stackSize="l">
 *       <ToolbarTitle>Media Area</ToolbarTitle>
 *       <div style={{ flex: '1' }} />
 *       <Button buttonType="primary">Action</Button>
 *     </ToolbarStack>
 *     <ToolbarButton>
 *       <SidebarLeftArrowIcon />
 *     </ToolbarButton>
 *   </Toolbar>
 *   <div
 *     style={{
 *       display: 'flex',
 *       justifyContent: 'center',
 *       alignItems: 'center',
 *       background: 'var(--light-bg-color)',
 *       height: '150px',
 *     }}
 *   >
 *     Main content
 *   </div>
 * </Canvas>;
 * ```
 *
 * @example With button group
 *
 * ```js
 * <Canvas ctx={ctx}>
 *   <Toolbar>
 *     <ToolbarStack stackSize="l">
 *       <ToolbarTitle>Media Area</ToolbarTitle>
 *       <div style={{ flex: '1' }} />
 *       <ButtonGroup>
 *         <ButtonGroupButton>First</ButtonGroupButton>
 *         <ButtonGroupButton selected>Second</ButtonGroupButton>
 *         <ButtonGroupButton>Third</ButtonGroupButton>
 *       </ButtonGroup>
 *     </ToolbarStack>
 *   </Toolbar>
 *   <div
 *     style={{
 *       display: 'flex',
 *       justifyContent: 'center',
 *       alignItems: 'center',
 *       background: 'var(--light-bg-color)',
 *       height: '150px',
 *     }}
 *   >
 *     Main content
 *   </div>
 * </Canvas>;
 * ```
 */
export function Toolbar(_a) {
    var children = _a.children, style = _a.style, className = _a.className;
    return (React.createElement("div", { className: classNames(s.Toolbar, className), style: style }, children));
}
//# sourceMappingURL=index.js.map